// Maps each product slug to the category page where it is listed.
// Used by ProductDetail's "Retour" button so users come back to the
// exact category they were browsing.

const SLUG_TO_ROUTE = {
  // /cartons-demenagement
  "carton-standard-renforce": "/cartons-demenagement",
  "carton-a-livres": "/cartons-demenagement",
  "carton-75-verres": "/cartons-demenagement",
  "carton-100-verres": "/cartons-demenagement",
  "carton-24-assiettes": "/cartons-demenagement",
  "carton-12-bouteilles": "/cartons-demenagement",
  "carton-penderie-petit": "/cartons-demenagement",
  "carton-penderie-grand": "/cartons-demenagement",
  "conteneur-boites-archives": "/cartons-demenagement",
  "carton-informatique-grand": "/cartons-demenagement",
  "carton-informatique-petit": "/cartons-demenagement",

  // /cartons-reconditionnes
  "carton-standard-reconditionne": "/cartons-reconditionnes",
  "carton-livres-reconditionne": "/cartons-reconditionnes",

  // /emballage-protection
  "papier-bulle-1x100m": "/emballage-protection",
  "papier-bulle-05x100m": "/emballage-protection",
  "papier-bulle-predecoupe-05x100m": "/emballage-protection",
  "papier-bulle-10m": "/emballage-protection",
  "bulle-kraft-125x100m": "/emballage-protection",
  "film-etirable": "/emballage-protection",
  "housse-matelas-1-place": "/emballage-protection",
  "housse-matelas-2-places": "/emballage-protection",
  "housse-matelas-king-size": "/emballage-protection",
  "papier-blanc-journal": "/emballage-protection",
  "couverture-demenagement": "/emballage-protection",

  // /fermeture-accessoires
  "rouleau-adhesif": "/fermeture-accessoires",
  "devidoir-pistolet-adhesif": "/fermeture-accessoires",
  "marqueur-permanent": "/fermeture-accessoires",
  "cutter": "/fermeture-accessoires",
  "chariot-demenagement": "/fermeture-accessoires",
  "diable": "/fermeture-accessoires",

  // /packs-cartons
  "pack-cartons-demenagement-t1": "/packs-cartons",
  "pack-cartons-demenagement-t2": "/packs-cartons",
  "pack-cartons-demenagement-t3": "/packs-cartons",
  "pack-cartons-demenagement-maison": "/packs-cartons",
};

// Human-readable label for each category route (used in the back button text).
const ROUTE_TO_LABEL = {
  "/cartons-demenagement": "Cartons de déménagement",
  "/cartons-reconditionnes": "Cartons reconditionnés",
  "/emballage-protection": "Emballage et protection",
  "/fermeture-accessoires": "Fermeture et accessoires",
  "/packs-cartons": "Kit cartons déménagement",
};

const FALLBACK_ROUTE = "/cartons-demenagement";

export const getCategoryRouteForSlug = (slug) =>
  SLUG_TO_ROUTE[slug] || FALLBACK_ROUTE;

export const getCategoryLabelForSlug = (slug) =>
  ROUTE_TO_LABEL[getCategoryRouteForSlug(slug)] || "Boutique";
